import { PageSection } from "../../components/layout/pageSection";
import { Title } from "../../components/layout/title";
import { Translation } from "../../components/dictionary/translation";
import { FunctionComponent } from "react";
import { useGetTermsQuery } from "../../store/api/texts/endpoints";
import { Loader } from "../../components/common/loader";
import { useTranslator } from "../../hooks/useTranslatable";

export const Terms: FunctionComponent = () => {
  const { data } = useGetTermsQuery();
  const translator = useTranslator();

  if (!data) {
    return <Loader />;
  }

  return (
    <PageSection
      title={
        <Title>
          <Translation k={"terms.title"} />
        </Title>
      }
    >
      <div
        className={"text"}
        dangerouslySetInnerHTML={{ __html: translator(data.text) }}
      />
    </PageSection>
  );
};
